import { trpc } from '@/lib/trpc';
import { useLogger } from '@/lib/logger';
import { toast } from '@/hooks/use-toast';
import { useTranslation } from 'react-i18next';

export function useOrgInvites() {
  const { t } = useTranslation('settings');
  const logger = useLogger();
  const utils = trpc.useUtils();

  const invitesQuery = trpc.users.listOrgInvites.useQuery();

  const resend = trpc.users.resendOrgInvite.useMutation({
    onSuccess: () => {
      utils.users.listOrgInvites.invalidate();
      toast({ title: t('toast.inviteResent') });
    },
    onError: (e) => {
      logger.error('Failed to resend invite', { error: e.message });
      toast({ title: t('toast.failedResend'), description: e.message, variant: 'destructive' });
    },
  });

  const cancel = trpc.users.cancelOrgInvite.useMutation({
    onSuccess: () => {
      utils.users.listOrgInvites.invalidate();
      toast({ title: t('toast.inviteCanceled') });
    },
    onError: (e) => {
      logger.error('Failed to cancel invite', { error: e.message });
      toast({ title: t('toast.failedCancel'), description: e.message, variant: 'destructive' });
    },
  });

  return { invitesQuery, resend, cancel };
}

